import React, { useContext } from 'react';
import styled from 'styled-components';

import { StoreContext } from '../../context/StoreContext';

const WishlistAddToCartContainer = styled.div`
    button {
        color: #fff;
        background-color: #f74d33;
        font-weight: bold;
        border-radius: 5px;
        border: 1px solid #f74d33;
        padding: 5px 0;
        max-width: 140px;
        width: 100%;
    }
`;

const WishlistAddToCart = ({ variantId }) => {
    const { addProductToCart } = useContext(StoreContext);

    function handleAddToCart(shopifyID) {
        addProductToCart(shopifyID);
    }
    return (
        <WishlistAddToCartContainer>
            <button onClick={() => handleAddToCart(variantId)}>
                Add to cart
            </button>
        </WishlistAddToCartContainer>
    );
};

export default WishlistAddToCart;
